import SpecialtyMixin from '@/shared/mixins/specialty.mixin'
import { mapActions } from 'vuex'
import moment from 'moment-timezone'
import CancelFileModal from '../../cancel-file/index.vue'
import ExamDetailsPreviewDocuments from '@/components/exames/exams-details/exam-details-preview-documents/index.vue'
import PendingExamsMixin from '@/shared/mixins/pending-exams.mixin'

moment.tz.setDefault('America/Sao_Paulo')
moment.locale('pt-BR')

export default {
  props: {
    details: {
      type: Object,
      default: () => ({
        patient: {
          name: '',
          gender: '',
          birthday: ''
        },
        speciality: {
          id: null,
          name: ''
        },
        examFiles: []
      })
    }
  },
  data() {
    return {
      birthDate: '',
      sex: [
        { name: this.$i18n.t('sex.male'), value: 'M' },
        { name: this.$i18n.t('sex.female'), value: 'F' }
      ],
      specialties: [],
      errorMessage: null,
      showCancelModal: false
    }
  },
  mixins: [SpecialtyMixin, PendingExamsMixin],
  components: {
    CancelFileModal,
    ExamDetailsPreviewDocuments
  },

  computed: {
    checkRequiredInputs() {
      return {
        patientName: !this.details.patient.name ? 'md-invalid' : undefined,
        birthDate: !this.birthDate ? 'md-invalid' : undefined,
        gender: !this.details.patient.gender ? 'md-invalid' : undefined,
        speciality: !this.details.speciality.id ? 'md-invalid' : undefined
      }
    },
    getAge() {
      if (this.birthDate) {
        if (this.birthDate.length === 10) {
          const today = new Date()
          const [day, month, year] = this.birthDate.split('/').map(Number)
          const birthDate = new Date(year, month - 1, day)

          let age = today.getFullYear() - birthDate.getFullYear()
          const monthDifference = today.getMonth() - birthDate.getMonth()
          const dayDifference = today.getDate() - birthDate.getDate()

          if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
            age--
          }
          return age
        }
      }
      return ''
    }
  },

  async mounted() {
    this.birthDate = this.formatDateToBR(this.details.patient.birthday)
    this.specialties = await this.getSpecialties()
  },

  methods: {
    ...mapActions(['changeUpdateGridExams']),

    formatDateToBR(date) {
      if (date) {
        const dataObj = new Date(date)
        const day = dataObj.getDate().toString().padStart(2, '0')
        const month = (dataObj.getMonth() + 1).toString().padStart(2, '0')
        const year = dataObj.getFullYear().toString()

        return `${day}/${month}/${year}`
      }
      return ''
    },

    formatDateToUSA(date) {
      if (date.length === 10) {
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}T00:00:00`
      }
      return date
    },

    checkDate(date) {
      const today = moment()
      if (date.length === 10) {
        const [day, month, year] = date.split('/')
        const formattedDate = moment(`${year}-${month}-${day}`, 'YYYY-MM-DD')

        return formattedDate.isValid() && formattedDate.isSameOrBefore(today)
      }
      return false
    },

    getGenderAsString(genderValue) {
      if (genderValue === 'M') return 'MASCULINO'
      if (genderValue === 'F') return 'FEMININO'
      return ''
    },
    async handleCancelExam() {
      try {
        await this.cancelExamFromInvalidFileStatus(this.details.examId, 'Cancelado por dados faltantes do paciente')
        this.$root.$emit('toast', {
          message: this.$t('cancel_success_message'),
          type: 'success'
        })
        this.changeUpdateGridExams(true)
        this.showCancelModal = false
        this.$emit('close')
      } catch (e) {
        this.$root.$emit('toast', {
          message: this.$t('cancel_error_message'),
          type: 'error'
        })
        console.error(e)
      }
    },
    async onCancelConfirmed() {
      await this.handleCancelExam()
    },
    async onSave() {
      const formData = {
        patientName: this.details.patient.name,
        birthDate: this.birthDate,
        gender: this.details.patient.gender
      }

      if (!formData.patientName || !formData.patientName.trim() || !formData.birthDate || !formData.gender) {
        this.$root.$emit('toast', {
          message: this.$t('required_fields_message'),
          type: 'error'
        })
        return
      }

      const body = {
        patientBirthDate: this.formatDateToUSA(this.birthDate).slice(0, 10),
        patientGender: this.getGenderAsString(this.details.patient.gender),
        patientName: this.details.patient.name
      }

      this.$root.$emit('showLoading')

      try {
        await this.updateExamFromPendingInformationStatus(this.details.examId, body)
        this.$root.$emit('toast', {
          message: this.$t('save_success_message'),
          type: 'success'
        })
        this.changeUpdateGridExams(true)
        this.$emit('close')
      } catch (e) {
        this.$root.$emit('toast', {
          message: this.$t('save_error_message'),
          type: 'error'
        })
        console.error(e)
      } finally {
        this.$root.$emit('hideLoading')
      }
    }
  }
}
